module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("THREE")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Brad’s face had a waxy sheen to it, making his pale skin almost translucent. His dark hair was still damp. The frown line that had formed a deep furrow across his brow years before, when TopMatch was screwed on funding, had vanished. It struck Anna that this was the first time she’d seen him relaxed for a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The roar of the wave lingered in her head. The drop off its crest had sent them plummeting into a turbulent froth. She’d lost her grip on Brad, and with it the air in her lungs. She’d been certain they were going to drown.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She reached out, hand trembling, to adjust the collar of his wetsuit. Her knuckles grazed the cold skin of his cheek. The Isurus’ hi-tech fabric, with its thermal layer lock, hadn’t kept its promise. He was stone cold.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She looked up. A Marin County cop was standing next to her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("How do you tell a child he’s lost his father? A wave of coffee-tinged nausea came sweeping up. She leaned over, vomiting onto the sand, cold and compressed from where the Pacific was beating its retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The cop crouched down, put a comforting hand on her shoulder. The touch tapped a well of tears. Her eyes misted over. The world about her began to spin.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Certain she was going to vomit again, she pitched forward, feeling herself falling into a spiraling black hole. Brad’s waxen face flashed through her mind’s eye, then another, a shadow face, whose appearance brought with it more dread than death itself.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Jack lay in bed waiting for his mom or dad to get to the front door and stop whoever it was from banging so loudly on it. One of them had to have opened the main gate for the person to get this far, so why in hell hadn’t they let them in?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He pulled the pillow over his head, but it did little to dull the sound. There was only one solution. He rolled out of bed and made his way sleepily across the room, to where he’d left his noise-canceling headphones.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Jack!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A stranger’s voice was calling his name from outside. He looked back at his bed. Gui. He bet the dog had escaped again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yawning, he threw on his sweats and headed down the stairs, expecting to find a neighbor with his dog in hand. Instead, he was surprised to find two cops on the doorstep.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Jack Jones?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“There’s been an accident. Your mom asked that we come and get you.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The taller one went on to explain it had happened on the beach, that he was needed there right now. Despite their calm demeanor, unease washed over him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They escorted him out, down the beach, speaking in hushed tones. Up ahead he could see the flashing lights of an ambulance at the water’s edge. Dread formed in the pit of his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“One moment, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A paramedic appeared. “Your mom’s not feeling so good. She’s resting,” he said, steering Jack by the arm around to the open back door of the ambulance, to where his mom was lying on a stretcher, wrapped in blankets, her eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“She’s in shock. We gave her a sedative. She’s okay,” said the paramedic.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad. Mom was in the ambulance. Where was Dad? He turned, looking out towards the roar of the ocean, to where a group of people were gathered in the swirling mist.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Before the cop could stop him, he jumped out of the ambulance and ran over, just as his dad was lifted into a black body bag.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01ab01ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 84
// module chunks = 0